import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Optional,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'vnm-form-actions',
  templateUrl: './form-actions.component.html',
  styleUrls: ['./form-actions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormActionsComponent implements OnInit {
  @HostBinding('class.p-form-actions') formActions = true;
  @HostBinding('class.is-rtl') get isReverse() {
    return this.direction === 'rtl';
  }

  @Output() cancel = new EventEmitter();

  @Input() submitLabel = 'app.submit';
  @Input() submitIcon = 'fa fa-fw fa-check';
  @Input() submitClass: string;
  @Input() cancelLabel = 'app.cancel';
  @Input() cancelIcon = 'fa fa-fw fa-times';
  @Input() cancelClass: string;
  @Input() direction = 'ltr';
  @Input() showCancel = true;

  submitDisabled = true;
  formContainer: NgForm | FormGroupDirective;

  get actionIcon() {
    return this.formContainer.submitted ? 'fa fa-fw fa-spinner-third' : this.submitIcon;
  }

  /**
   * form: NgForm - will be injected if we are contained within <form #userForm="ngForm">
   *
   * formGroup: FormGroupDirective - will be injected if we are contained within <form [formGroup]="userForm"
   */
  constructor(@Optional() private form: NgForm, @Optional() private formGroup: FormGroupDirective) {}

  ngOnInit() {
    this.formContainer = this.form || this.formGroup;
    // If the form is pre-filled out
    this.submitDisabled = this.formContainer.disabled || this.formContainer.invalid;
    if (this.formContainer) {
      this.formContainer.statusChanges.pipe(untilDestroyed(this)).subscribe((_) => {
        this.submitDisabled = this.formContainer.disabled || this.formContainer.invalid || this.formContainer.submitted;
      });
    }
  }

  reset(model?: any) {
    this.formContainer.resetForm(model || this.formContainer.value);
    this.submitDisabled = this.formContainer.disabled || this.formContainer.invalid || this.formContainer.submitted;
  }

  onCancel() {
    this.cancel.emit();
  }

  onSubmit() {
    this.submitDisabled = this.formContainer.disabled || this.formContainer.invalid || this.formContainer.submitted;
  }
}
